
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Numero from '@/extend/classes/Numero';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeNumero' })

export default class storeNumero extends VuexModule {
  // States
  private reccords: Numero[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get numeroLoading (): boolean {
    return this.dataLoading;
  }
  private get numeroRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get numeroLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewNumero() {
    return (): Numero => { 
      return this.getNumero(0, true);
    }
  }

  
  public get getNumero () {
    return (id: number, canCreate = false): Numero => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Numero can't be 0")
        return new Numero();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Numero();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Numero.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromNumero(data.reccords[0] as Numero);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listNumero (): Numero[] {
    return this.reccords;
  }

  public get listConfigNumero (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mNumeroRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mNumeroClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mNumeroLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mNumeroLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Numero.fromJson(reccord as Numero));
    })
    Numero.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mNumeroConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mNumeroCreated (obj: Numero): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareNumero(obj)) {
          api.fromNumero(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareNumero(obj)) {
            api.fromNumero(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mNumeroUpdated (obj: Numero): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareNumero(obj)) {
          api.fromNumero(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mNumeroDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerNumero (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.numeroRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerNumero(this.numeroCreated, this.numeroUpdated, this.numeroDeleted);
          this.mNumeroRegistered();
        } else {
          setTimeout(() => resolve(this.registerNumero(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.numeroLoading && !this.numeroLoaded) {
          this.mNumeroLoading(true);
          return Numero.list(filter)
            .then((data: ListData) => {
              this.mNumeroLoaded(data);
              this.mNumeroLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredNumero (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.numeroLoading) {
        this.mNumeroLoading(true);
        return Numero.list(filter)
          .then((data: ListData) => {
            this.mNumeroLoaded(data);
            this.mNumeroLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createNumero (obj: Numero): Promise<Numero> {
    return new Promise((resolve, reject) => {
      return Numero.fromJson(obj).createForStoreNumero()
        .then((reccords) => {
          this.mNumeroCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateNumero (obj: Numero): Promise<Numero> {
    return new Promise((resolve, reject) => {
      return Numero.fromJson(obj).updateForStoreNumero()
        .then((reccords) => {
          this.mNumeroUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteNumero (obj: Numero): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Numero.fromJson(obj).deleteForStoreNumero()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mNumeroDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private numeroCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mNumeroConfigUpdated(config)
    const obj = objConfig.obj as Numero;
    this.mNumeroCreated(Numero.fromJson(obj));
  }

  @Action
  private numeroUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mNumeroConfigUpdated(config)
    const obj = objConfig.obj as Numero;
    this.mNumeroUpdated(Numero.fromJson(obj));
  }

  @Action
  private numeroDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Numero;
    this.mNumeroDeleted(obj.id);
  }
}
